import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Divider } from '@kambi/spark';
import { BetOfferLabelOptionsTypeSchema } from '@kambi/betting-client-helpers';

import classes from '../../App.module.css';
import CodeBlock from 'components/layout/code-block/CodeBlock';
import TabsBlock from 'components/layout/tabs-block/TabsBlock';
import TestBlock from 'components/layout/test-block/TestBlock';
import Description from 'components/betOffer-label/description/Description';
import { UtilsTypes } from 'constants/utilsTypes';

const BetOfferLabel = () => {
    const navigate = useNavigate();

    return (
        <div className={classes.Wrapper}>
            <Button
                color="primary"
                variant="outlined"
                onClick={() => navigate('/')}
            >
                Back
            </Button>
            <div className={classes.Divider}>
                <Divider />
            </div>
            <div className={classes.Content}>
                <div className={classes.Title}>Bet Offer label</div>
                <div className={classes.Main}>
                    <Description />
                    <Divider />
                    <CodeBlock
                        title="General input for the betOfferLabel() method"
                        initialDisplayedCode={`{
    "outcomeId": 3190996815,
    "selections": {},
    "multiPositionBetOfferLabelOneLine": false,
    "betOffer": {
        "id": 2, `}
            moreCode={`
        "betOfferType": {
            "id": 2,
            "name": "Match"
        },
        "criterion": {
            "label": "Full Time"
        },
        "outcomes": [
            {
                "id": 3190996815,
                "participant": "Ecuador"
            },
            {
                "id": 3190996818,
                "participant": "South Ecuador"
            }
        ]
    },
    "event": {
            "id": 1018562026,
            "tags": ["BET_BUILDER", "MATCH"]
        }
}`}
                    />
                    <TabsBlock
                        title="Examples: Type of betOffer labels that can be returned based on
                the betOffer type"
                        type={UtilsTypes.BETOFFER_LABEL}
                    />
                    <TestBlock
                        validationSchema={BetOfferLabelOptionsTypeSchema}
                        title="You can test the betOfferLabel() method by adding the input parameters as
                a JSON object in the below textarea, click Run and check the
                Output in the right"
                        type={UtilsTypes.BETOFFER_LABEL}
                    />
                </div>
            </div>
        </div>
    );
};

export default BetOfferLabel;
